import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController, ToastController, App } from 'ionic-angular';
// import { Clipboard } from '@ionic-native/clipboard';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the TransferPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-transfer',
  templateUrl: 'transfer.html',
})
export class TransferPage {

    loginId: string;
	email: string;
    api_key: string;
    version: string;

	list: any = [];
	deposit: any = [];
	name: any = [];
    
    balance: any = [];
	value: string;
	coin_unit: string;
	cash_room_unit: string;
	bonus_room_unit: string;
    
	texts: any = [];
    language : string;

    isSend : boolean = true;

	constructor(
		public navCtrl: NavController,
        public navParams: NavParams,
		public alertCtrl: AlertController,
		public modalCtrl: ModalController,
		public toastCtrl: ToastController,
		// private barcodeScanner: BarcodeScanner,
		// private camera: Camera,
        // private clipboard: Clipboard,
        private http: HttpService,
		public app: App
	) {
		// this.segment = navParams.get("target");
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}

		//// 페이지 이름
		localStorage.setItem("pageName", "transfer");
		this.loginId = localStorage.getItem("loginId");
		this.email = localStorage.getItem("email");
		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		this.coin_unit = localStorage.getItem("coin_unit");
		this.cash_room_unit = localStorage.getItem("cash_room_unit");
		this.bonus_room_unit = localStorage.getItem("bonus_room_unit");

        this._get_texts();

		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).transfer;
	}

    _deposit(idx) {
        let url = "room/transfer/index/deposit";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            idx: idx
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
                this._init();

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
    }

    keyDown(event) {
        if (this.value == undefined || this.value == null) {
			var tmps: string = "";
		} else {
			tmps = this.value;
		}
		
		this.value = tmps.replace(/[^0-9]/g, "");
    }

    keyUp() {
        if(this.value != null || this.value != "") {
            let tmps = this.value;
            this.value = tmps.replace(/[^0-9]/g, "");
            
            // this.floor();
        } else {

        }
        
	}

    _send(){
        // let alert = this.alertCtrl.create({
        //     message: this.texts.alertM_ready,
        //     buttons: ['OK']
        // });
        // alert.present();

		this.isSend = false;

		if (!this.value || this.value.length == 0 || this.value =="0") {
			const toast = this.toastCtrl.create({
				message:  this.texts.toastM_amount,
				duration: 2000,
				position: 'middle'
			});
            toast.present();
            this.isSend = true;
			return false;
		}

        let url = "room/transfer/index/bonus";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version,
            value: this.value
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();

                this.isSend = true;
                this._init();

			} else if(res.result ==="NO"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();
                this.isSend = true;

			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();
                this.isSend = true;

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isSend = true;
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                this.isSend = true;
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
            this.isSend = true;
		});

        
	}

	_init() {		
		this.deposit = [];
		this.list = [];
		
        let url = "room/transfer";
		let body = JSON.stringify({ 
			api: this.api_key,
            language: this.language,
            version: this.version
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
                this.balance = res.balance;
                // this.name = res.name;

                if (res.deposit != undefined) {   
                    this.deposit = res.deposit;
                }

                if (res.list != undefined) {   
                    this.list = res.list;
                }
				
				// if(res.list != undefined) {
				// 	this.list = res.list;
				// 	this.max_length = res.list.length;
				// 	this.params = [];
				// 	this.count = 0;
				// 	for (var i = 0; i < 9; i++) {
				// 		if(this.max_length <= this.count) break;
				// 		this.params.push(this.items[this.count]);
				// 		this.count++;
				// 	}
				// }
			} else if(res.result ==="DONOT"){
                let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
                // this.navCtrl.pop();

			} else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				this.navCtrl.pop();
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		},(err)=>{
			let alert = this.alertCtrl.create({
				message: this.texts.alertM_err,
				buttons: ['OK']
			});
			alert.present();
		});
	}

    // _list_detail(item) {
    //     let modal = this.modalCtrl.create(BonusdetailPage, {name: item.name, date: item.date});
    //     modal.present();
    //     modal.onDidDismiss( tab => {
    //         if (tab != '') {
    //             this.segment = item.name;
    //         }
    //     });
    // }

    // _list_three(date) {
    //     let modal = this.modalCtrl.create(BonusdetailPage, {tab: 'three', date: date});
    //     modal.present();
    //     modal.onDidDismiss( tab => {
    //         if (tab != '') {
    //             this.segment = 'btn03';
    //         }
    //     });
    // }
}



// WEBPACK FOOTER //
// ./src/pages/transfer/transfer.ts